<script setup lang="ts">
import { onBeforeMount, Ref, ref, watch, toRefs, computed } from "vue";
import DocumentAlertNotifiableDO = App.Data.Alerts.DocumentAlertNotifiableDO;
import { useBaseStore } from "@/stores/base";
import { useApiClient } from "@/api/client";
import PublicUserDO = App.Data.PublicUserDO;
import { required } from "@/ui/validation/validationRules";
const isDialogVisible = defineModel<boolean>();
import { t } from "@/plugins/i18n";
import { toastApiResult } from "@/toaster";
import DocumentAlertDO = App.Data.Alerts.DocumentAlertDO;

const emit = defineEmits(["user-added"]);

const props = defineProps<{
	alert: DocumentAlertDO;
	configuredNotifiables: DocumentAlertNotifiableDO[];
	availableUsers: PublicUserDO[];
}>();
const { alert, configuredNotifiables, availableUsers } = toRefs(props);
const userToAssign = ref(null);

const filteredUsers = computed((): PublicUserDO[] => {
	const userIds = [useBaseStore().currentUser.id];
	configuredNotifiables.value.forEach((notifiable) =>
		userIds.push(notifiable?.notifiable?.id)
	);
	return availableUsers.value.filter((user) => !userIds.includes(user.id));
});

const assignNotifiable = async () => {
	const response = await toastApiResult(
		useApiClient("alerts").assignNotifiableUser(
			alert.value.id,
			userToAssign.value
		)
	);
	if (response.isOk()) {
		emit("user-added");
		isDialogVisible.value = false;
	}
};
</script>

<template>
	<v-dialog v-model="isDialogVisible" persistent width="60vw" max-width="600px">
		<v-card elevation="0" class="help">
			<v-toolbar style="border-radius: 0 !important" color="lightprimary" flat>
				<v-toolbar-title
					><i class="fa-duotone fa-user-plus fa-xl mr-3"></i>
					Add recipient
				</v-toolbar-title>
				<v-spacer></v-spacer>

				<v-btn icon @click="isDialogVisible = false">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-divider />
			<div class="pa-5">
				<h6 class="text-h6 mb-3">User:</h6>
				<v-autocomplete
					placeholder="Select a user"
					:items="filteredUsers"
					item-title="name"
					item-value="id"
					v-model="userToAssign"
					:rules="[required(t)]"
				>
				</v-autocomplete>
			</div>
			<v-divider />
			<v-card-actions>
				<v-btn
					color="primary"
					variant="flat"
					:disabled="!userToAssign"
					@click="assignNotifiable()"
					>Add</v-btn
				>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<style scoped lang="scss"></style>
